<!-- `border` is static so every state has the same box: the 1px comes out of the content once, at
     construction, instead of appearing when an invitation is answered. The card is `h-full` in a
     border-box grid, so that costs 2px of content height on every card — visible only in a slot too
     short to fit the second line anyway. -->
<div
    [appEventContextMenu]="event()"
    [appEventContextMenuDisabled]="!withContextMenu()"
    role="button"
    class="rounded-md p-2 h-full flex flex-col text-sm whitespace-nowrap border select-none hover:cursor-pointer focus-visible:outline-dashed focus-visible:outline-1"
    [ngClass]="[
      ['text-background', !!selected()],
      ['text-gray-600',   isPast() && !selected()],
      ['pl-2.5',     isPending()],
      ['pl-2.5',     isTentative()],
      ['border-l-2', isSettled()]
    ]"
    [style.outline-color]="eventColor()"
    [style.border-color]="borderColor()"
    [style.background-color]="selected() ? eventColor() : bgColor()"
    [style.--hover-bg-color]="selected() ? eventColor() : hoverColor()"
    [attr.tabindex]="tabindex() ?? -1"
    [attr.aria-label]="'Event: ' + event().title + ' at ' + (event().startTime | dateFormat: 'timeShort')"
  >
    <span
      class="flex flex-row gap-2 font-medium overflow-hidden text-ellipsis shrink-0"
      [class.text-gray-950]="!isPast() && !selected()"
    >
      @if (event().pinned) {
        <stch-pinned-icon size="s" [active]="true"/>
      }
      @if (event().flagged) {
        <app-flagged-icon size="s"/>
      }
      @if (event().snoozed) {
        <app-snoozed-icon size="s" [date]="event().snoozed"/>
      }
      @if (event().followed) {
        <app-followed-icon size="s" [date]="event().followed"/>
      }
      @if (statusPrefix()) {
        <span class="shrink-0">{{ statusPrefix() }}</span>
      }

      <!-- Own block, and `min-w-0` so it may shrink: the row's `text-ellipsis` never reached a bare
           text node, which is an anonymous flex item and does not inherit `text-overflow`. -->
      <span class="min-w-0 overflow-hidden text-ellipsis">{{ event().title ? event().title : '(No Title)' }}</span>
    </span>
    <span class="overflow-hidden text-ellipsis">
      @if (event().allDay) {
        All Day
      } @else {
        {{ event().startTime | dateFormat: 'timeRange' : event().endTime }}
      }
    </span>
  </div>
